import { useContext } from 'react';
import { PropertyContext } from '../context/PropertyContext/PropertyContext';
export const useGetAdditionalPropertyValue = () => useContext(PropertyContext).getAdditionalPropertyValue;